import React from 'react';
import { Upload, FileSpreadsheet } from 'lucide-react';
import Dropdown from '../ui/Dropdown';

// =============================================================================
// UploadControls — the standard batch-upload affordance (Sep 2026).
//
// One split button replaces the old side-by-side "Template" + "Upload" pair
// that LeaveRosterTab and OperationsTab each hand-rolled: the main segment
// uploads, the chevron menu offers the matching template download. Both tabs
// share App's single hidden file input + type-agnostic /api/batch-upload
// handler; only the template type differs.
//
//   templateType : 'leaves' | 'locations' | 'staff' — passed to downloadTemplate
//   variant      : Button variant for the split ('primary' where upload is the
//                  tab's main action, 'secondary' where it isn't)
// =============================================================================

const TEMPLATE_SUBLABELS = {
  leaves: 'Excel format for leave entries',
  locations: 'Excel format for clinic setup',
  staff: 'Excel format for the staff list',
};

const UploadControls = ({
  downloadTemplate,
  handleFileUpload,
  fileInputRef,
  templateType,
  variant = 'primary',
  disabled = false,
}) => (
  <div className="flex items-center">
    <input
      type="file"
      ref={fileInputRef}
      onChange={handleFileUpload}
      accept=".xlsx, .xls, .csv"
      className="hidden"
    />
    <Dropdown
      align="right"
      disabled={disabled}
      splitAction={{
        label: 'Upload',
        icon: Upload,
        variant,
        disabled,
        onClick: () => fileInputRef.current && fileInputRef.current.click(),
        className: 'h-[36px] px-5 font-bold text-xs',
      }}
      items={[
        {
          id: 'template',
          label: 'Download template',
          icon: FileSpreadsheet,
          sublabel: TEMPLATE_SUBLABELS[templateType] || `Excel template (${templateType})`,
          onSelect: () => downloadTemplate(templateType),
        },
      ]}
    />
  </div>
);

export default UploadControls;
